import type { InfoCardProps } from "@components/InfoCardProps.js";
import type { Tenant } from "@core/schema/Tenant.js";
import { getCrmPath } from "@core/schema/paths/getCrmPath.js";
import { getDigitalizationAndAutomationPath } from "@core/schema/paths/getDigitalizationAndAutomationPath.js";
import { getEcommercePath } from "@core/schema/paths/getEcommercePath.js";
import { getIntegrationsPath } from "@core/schema/paths/getIntegrationsPath.js";
import { getKiosksPath } from "@core/schema/paths/getKiosksPath.js";
import { getWebAppsPath } from "@core/schema/paths/getWebAppsPath.js";
import { getWebsitesPath } from "@core/schema/paths/getWebsitesPath.js";

export function getWhatWeDevelopGastro(tenant: Tenant): InfoCardProps[] {
	return [
		{
			title: "Objednávkové systémy a kiosky na míru",
			desc: `Vyvíjíme objednávkové systémy, rezervační systémy i [${getKiosksPath(
				tenant,
			)}][[kiosková řešení]] na míru, včetně integrací tiskáren, kamer a platebních terminálů.`,
		},
		{
			title: "Webové a mobilní aplikace",
			desc: `Od myšlenky až po realizaci za vás vyřešíme [${getWebAppsPath(tenant)}][[webovou]] i mobilní aplikaci, která nakopne růst podnikání hotelu i gastro podniku.`,
		},

		{
			title: "Weby a e-shopy na míru",
			desc: `Chcete své služby odprezentovat přehledně online? Již 16 let vyvíjíme [${getWebsitesPath(tenant)}][[firemní weby]], [${getEcommercePath(tenant)}][[e-shopy]] i portály na míru včetně administrace a napojení na další systémy.`,
		},
		{
			title: "Sjednocení „pod jednu střechu“",
			desc: `Zajistíme, abyste vše mohli řídit z jednoho místa (aplikace): od objednávek přes zásobování a skladové zásoby až po distribuci nebo marketingové aktivity.`,
		},
		{
			title: "Integrace systémů",
			desc: `Propojením ([${getIntegrationsPath(tenant)}][[integrací]]) systémů minimalizujeme manuální práci, snížíme chybovost a ušetříme vám spoustu času a starostí. Rádi vás napojíme i na systémy třetích stran.`,
		},
		{
			title: "Automatizace a digitalizace",
			desc: `Stále spoléháte na papír a Excel? [${getDigitalizationAndAutomationPath(tenant)}][[Digitalizací a automatizací]] procesů vám snížíme náklady, ušetříme čas a odbouráme rutinu i administrativu.`,
		},
		{
			title: "CRM",
			desc: `Podle vašich potřeb umíme navrhnout a vyvinout i systém pro řízení vztahu se zákazníky ([${getCrmPath(tenant)}][[CRM]]).`,
		},
		{
			title: "Platební systémy",
			desc: "Zbavíme vás veškerých starostí s implementací platebních systémů i napojením na hardwarová zařízení.",
		},
	];
}
